import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, renderSlot as _renderSlot, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["data-section-id"]
const _hoisted_2 = {
  key: 1,
  class: "absolute right-2 top-2 flex items-center gap-1 border ct-border-1 rounded-lg px-2 py-1 shadow-md ct-bg-1 z-[200]"
}

import { computed, inject, ref } from "vue";
import { ButtonTertiaryIconXs } from "@easy/ui/buttons";
import {
    AddIcon,
    ArrowDownIcon,
    DragDropIcon,
    PencilSquareIcon,
    RecycleBinIcon,
    RocketIcon,
    VisibleIcon,
} from "@easy/ui/icons";
import { useEditorActions } from "@/views/tools/page/utils/useEditorActions";
import { useState } from "@/store/vuex-composition-mappers";
import { SectionToolInfo } from "@/apps/page/section-tool-info.interface";

const dragHandleClass = "section-drag-handle";

export default /*@__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false,
},
  __name: 'EditableSection',
  props: {
    sectionId: {},
    isFirst: { type: Boolean, default: false },
    isLast: { type: Boolean, default: false },
    enabled: { type: Boolean, default: false },
    toolInfo: { default: () => ({
            isTool: false,
        }) }
  },
  setup(__props: any) {

const props = __props;



const displayOnlyIfPublishedForTool = computed(() => {
    if (!props.toolInfo || !props.toolInfo.isTool) return true;
    // display only if the tool is published
    return props.toolInfo.isPublished;
});
const {
    editSection,
    moveSection,
    removeSection,
    hideSection,
    addSection,
    createToolProject,
    publishToolProject,
} = useEditorActions();

// @ts-expect-error
const { preview } = useState("shared/view", ["preview"]);
const isHovered = ref(false);

const isMinimap = inject("isMinimap");

return (_ctx: any,_cache: any) => {
  return (_unref(preview) && !_unref(isMinimap))
    ? (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        class: ["relative group editable-section", { 'pointer-events-none': !_ctx.enabled }],
        "data-dnd": "section",
        "data-section-id": _ctx.sectionId,
        onMouseenter: _cache[9] || (_cache[9] = ($event: any) => (isHovered.value = true)),
        onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (isHovered.value = false))
      }, _ctx.$attrs), [
        (isHovered.value && !_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "absolute -top-[14px] rounded-md left-1/2 -translate-x-1/2 px-2 py-1 text-xs font-medium bg-blue-500 text-white uppercase flex items-center gap-1 z-[100]",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(addSection) && _unref(addSection)(...args)), ["stop"]))
            }, [
              _createVNode(_unref(AddIcon), { class: "w-4 h-4" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("page.sections.add_section")), 1)
            ]))
          : _createCommentVNode("", true),
        (isHovered.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(ButtonTertiaryIconXs), {
                class: _normalizeClass([dragHandleClass, "!cursor-move"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DragDropIcon))
                ]),
                _: 1
              }),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "border-l ct-border-1 h-4 w-px" }, null, -1)),
              (_ctx.toolInfo.isTool && !_ctx.toolInfo.isCreated)
                ? (_openBlock(), _createBlock(_unref(ButtonTertiaryIconXs), {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(createToolProject)({ tool: _ctx.toolInfo.type, sectionId: _ctx.sectionId })), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AddIcon))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.toolInfo.isTool && _ctx.toolInfo.isCreated && !_ctx.toolInfo.isPublished)
                ? (_openBlock(), _createBlock(_unref(ButtonTertiaryIconXs), {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(publishToolProject)({ uuid: _ctx.toolInfo.uuid, tool: _ctx.toolInfo.type })), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(RocketIcon))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.toolInfo.isTool || (_ctx.toolInfo.isCreated && _ctx.toolInfo.isPublished))
                ? (_openBlock(), _createBlock(_unref(ButtonTertiaryIconXs), {
                    key: 2,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(editSection)(_ctx.sectionId)), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PencilSquareIcon))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(ButtonTertiaryIconXs), {
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(hideSection)(_ctx.sectionId)), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(VisibleIcon))
                ]),
                _: 1
              }),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "border-l ct-border-1 h-4 w-px" }, null, -1)),
              _createVNode(_unref(ButtonTertiaryIconXs), {
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(moveSection)(_ctx.sectionId, -1)), ["stop"])),
                disabled: _ctx.isFirst
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowDownIcon), { class: "rotate-180" })
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_unref(ButtonTertiaryIconXs), {
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_unref(moveSection)(_ctx.sectionId, 1)), ["stop"])),
                disabled: _ctx.isLast
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowDownIcon))
                ]),
                _: 1
              }, 8, ["disabled"]),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "border-l ct-border-1 h-4 w-px" }, null, -1)),
              _createVNode(_unref(ButtonTertiaryIconXs), {
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_unref(removeSection)(_ctx.sectionId)), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(RecycleBinIcon), { class: "text-red-500" })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.enabled && isHovered.value && displayOnlyIfPublishedForTool.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass([[
                _ctx.isFirst ? 'top-0 bottom-0' : '-top-[2px] bottom-0',
                _ctx.isLast ? 'bottom-0' : '-bottom-[2px]',
            ], "absolute left-0 right-0 border-2 transition-colors border-blue-500 z-50"])
            }, null, 2))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default"),
        (isHovered.value && !_ctx.isLast)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: "absolute left-1/2 -translate-x-1/2 -bottom-[10px] rounded-md px-2 py-1 text-xs font-medium bg-blue-500 text-white uppercase flex items-center gap-1 z-[50]",
              onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_unref(addSection) && _unref(addSection)(...args)), ["stop"]))
            }, [
              _createVNode(_unref(AddIcon), { class: "w-4 h-4" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("page.sections.add_section")), 1)
            ]))
          : _createCommentVNode("", true)
      ], 16, _hoisted_1))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})